import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { user } from 'src/actions';
import { transformFetchedHackathons } from 'src/components/Hackathons';
import HackList from 'src/components/Hackathons/HacksList';
import { ADD_HACKATHON_URL } from 'src/constants/configuration';
import './UserHackatons.scss';
import { Mixpanel } from '../../Mixpanel';


class UserHackatons extends Component {

  componentDidMount() {
    this.props.refetchUserEvents();
  }

  render() {

    const { history } = this.props;
    const { hackathons } = transformFetchedHackathons(this.props.userEvents);
    return (
      <div className='cabinet_hackatons'>
        <div className="hackatons_add-btn-wrapper">
          <button className='hackatons_add-btn' onClick={() => {Mixpanel.track('Account', {'My hackathons': 'Add hackathon'}); history.push(ADD_HACKATHON_URL, { from: 'account' })}}>
            Рассказать о хакатоне
          </button>
          <button className='hackatons_add-btn' onClick={() => {Mixpanel.track('Account', {'My hackathons': 'To hackathons'}); history.push('/hackathons')}}>Календарь хакатонов</button>
        </div>
        <div className='separate-line' />
        <div className="hackatons-wrapper">
          <HackList hackathons={hackathons} dontSplitByWeeks={true}/>
        </div>
      </div>
    )
  }
}
UserHackatons.propTypes = {
  userEvents: PropTypes.array.isRequired,
  refetchUserEvents: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
}

function mapStateToProps(state) {
  return {
    userEvents: state.user.events,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    refetchUserEvents: user.refetchUserEvents,
  })(UserHackatons));



// WEBPACK FOOTER //
// ./src/components/Account/UserHackatons/index.js